/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundVariantDto } from '../../models/backend-venture-fund-variant-dto';

export interface VentureFundsVentureFundVariantsCopyCreate$Params {
  id: number;
}

export function ventureFundsVentureFundVariantsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundVariantsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundVariantsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundVariantDto>;
    }),
  );
}

ventureFundsVentureFundVariantsCopyCreate.PATH = '/api/venture_funds/venture-fund-variants/{id}/copy/';
